import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import App from "./App";
import { ConfigProvider, App as AntApp, unstableSetRender } from "antd";
import "antd/dist/reset.css";
import "./index.css";

// AntD 5's static popups (message.success/error, notification, Modal.confirm)
// render through ReactDOM.render, which React 19 removed — without this hook
// they silently never appear. Give AntD React 19's createRoot instead.
// (Same as @ant-design/v5-patch-for-react-19; remove when moving to AntD 6.)
type RootContainer = (Element | DocumentFragment) & { _reactRoot?: ReactDOM.Root };
unstableSetRender((node, container) => {
  const c = container as RootContainer;
  c._reactRoot ||= ReactDOM.createRoot(c);
  const root = c._reactRoot;
  root.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
    delete c._reactRoot;
  };
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigProvider theme={{ token: { colorPrimary: "#1677ff" } }}>
        <AntApp>
          <App />
        </AntApp>
      </ConfigProvider>
    </BrowserRouter>
  </Provider>
);
